import { IStatusEtapaBody } from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import {
    InserirCasoStatusService,
    ListarStatusEtapaFixosService,
    ListarStatusEtapasDinamicasService,
} from "../../../Services/Repasse/StatusEtapa/StatusEtapaServices";
import { Controller } from "../../Controller";

export async function ListarStatusEtapaController(
    idEtapaCategoriaAtendimentoTipoCaso: number,
    idCaso: number
) {
    return Controller(
        ListarStatusEtapasDinamicasService(
            idEtapaCategoriaAtendimentoTipoCaso,
            idCaso
        )
    );
}

export async function ListarStatusEtapaFixosController(
    idEtapaTipoCaso: number,
    idCaso: number
) {
    return Controller(ListarStatusEtapaFixosService(idEtapaTipoCaso, idCaso));
}

export async function InserirCasoStatusController(
    requestBody: IStatusEtapaBody
) {
    return Controller(InserirCasoStatusService(requestBody));
}
